"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _Fonts = require("../00_environment/Fonts");

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _KeyValueElement = _interopRequireDefault(require("../01_atoms/KeyValueElement"));

var _PlaceHolderElement = _interopRequireDefault(require("../01_atoms/PlaceHolderElement"));

var _Icon = _interopRequireDefault(require("../01_atoms/Icon"));

var _PaymentIcon = _interopRequireDefault(require("../01_atoms/PaymentIcon"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SettingsPageUI = function SettingsPageUI(_ref) {
  var loggedIn = _ref.loggedIn,
      selectedLanguage = _ref.selectedLanguage,
      version = _ref.version,
      card = _ref.card,
      _ref$savedPassengers = _ref.savedPassengers,
      savedPassengers = _ref$savedPassengers === void 0 ? [] : _ref$savedPassengers,
      _ref$onEditPassengers = _ref.onEditPassengers,
      onEditPassengers = _ref$onEditPassengers === void 0 ? function () {} : _ref$onEditPassengers,
      _ref$onConnect = _ref.onConnect,
      onConnect = _ref$onConnect === void 0 ? function () {} : _ref$onConnect,
      _ref$onLogOut = _ref.onLogOut,
      onLogOut = _ref$onLogOut === void 0 ? function () {} : _ref$onLogOut,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      _ref$onDeleteCard = _ref.onDeleteCard,
      onDeleteCard = _ref$onDeleteCard === void 0 ? function () {} : _ref$onDeleteCard,
      _ref$onDebugToggle = _ref.onDebugToggle,
      onDebugToggle = _ref$onDebugToggle === void 0 ? function () {} : _ref$onDebugToggle,
      _ref$onLanguageEdit = _ref.onLanguageEdit,
      onLanguageEdit = _ref$onLanguageEdit === void 0 ? function () {} : _ref$onLanguageEdit,
      _ref$isDebugOn = _ref.isDebugOn,
      isDebugOn = _ref$isDebugOn === void 0 ? false : _ref$isDebugOn,
      _ref$debugChannel = _ref.debugChannel,
      debugChannel = _ref$debugChannel === void 0 ? "<unset>" : _ref$debugChannel,
      userEmail = _ref.userEmail,
      userPassenger = _ref.userPassenger,
      _ref$onUserPassengerE = _ref.onUserPassengerEdit,
      onUserPassengerEdit = _ref$onUserPassengerE === void 0 ? function () {} : _ref$onUserPassengerE,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace("SettingsPageUI");
  var passengerSectionTitle = t("No passenger saved");

  if (savedPassengers.length === 1) {
    passengerSectionTitle = t("1 passenger saved");
  } else if (savedPassengers.length > 1) {
    passengerSectionTitle = t("{x} passengers saved", {
      x: savedPassengers.length
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t("Settings")
  }, /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: t("About you"),
    titlePadding: 10,
    backgroundColor: "white"
  }, loggedIn && _checkTypes["default"].nonEmptyString(userEmail) && /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    title: t("E-mail:"),
    value: /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: "gray"
      }
    }, userEmail)
  }), /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    title: t("Passenger information:"),
    onClick: onUserPassengerEdit,
    value: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row"
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: "gray"
      }
    }, userPassenger ? "".concat(userPassenger.firstName, " ").concat(userPassenger.lastName, " (").concat(userPassenger.ssn, ")") : t("Add")), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "angle right",
      style: {
        color: "gray",
        cursor: "pointer",
        marginLeft: 15,
        marginBottom: 1
      }
    }))
  }), /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    onClick: onLanguageEdit,
    title: t("Language:"),
    value: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row"
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: "gray"
      }
    }, selectedLanguage), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "angle right",
      style: {
        color: "gray",
        cursor: "pointer",
        marginLeft: 15,
        marginBottom: 1
      }
    }))
  })), /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: t("Your payment information"),
    titlePadding: 10,
    backgroundColor: "white"
  }, !card && /*#__PURE__*/_react["default"].createElement(_PlaceHolderElement["default"], null, t("No credit or debit card saved")), card && /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    title: /*#__PURE__*/_react["default"].createElement("div", {
      style: (0, _Fonts.withPlaceholderFont)({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-start"
      })
    }, /*#__PURE__*/_react["default"].createElement(_PaymentIcon["default"], {
      id: card.brand.toLowerCase(),
      style: {
        display: "inline",
        height: "1.2rem",
        marginRight: 10
      }
    }), "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ".concat(card.last4)),
    value: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "close",
      style: {
        color: "gray",
        cursor: "pointer"
      },
      onClick: onDeleteCard
    })
  })), /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: t("Passenger information"),
    subtitles: t("Super useful to avoid entering data twice"),
    titlePadding: 10,
    backgroundColor: "white"
  }, /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    onClick: onEditPassengers,
    title: passengerSectionTitle,
    value: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "angle right",
      style: {
        color: "gray",
        cursor: "pointer"
      }
    })
  })), /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: t("App information"),
    titlePadding: 10,
    backgroundColor: "white"
  }, /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    title: t("Version:"),
    value: /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: "gray"
      }
    }, version)
  })), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    fluid: true,
    primary: !loggedIn,
    color: loggedIn ? "google plus" : null,
    onClick: loggedIn ? onLogOut : onConnect
  }, loggedIn ? t("Log out") : t("Log in")))));
};

var _default = SettingsPageUI;
exports["default"] = _default;